/* eslint-disable */
import React from "react";
import { useLocation } from "react-router";
import cn from "classnames";

import { NavLinkProps } from "./types";
import { useNavLinkStyles } from "./styles";
import Link from "../Link";

export function NavLink(props: NavLinkProps) {
  const classes = useNavLinkStyles(props);
  const { children, label, disabled, to, isHeaderLink, targetBlank, onClick } = props;
  const location = useLocation();
  const active = location.pathname === to;
  const parentClassesLink =
    (props.parentClasses && isHeaderLink && !!active ? (props.parentClasses as any).notHoverLink : (props.parentClasses as any).link) || "";

  return (
    <Link
      className={cn(classes.link, parentClassesLink)}
      active={active}
      disabled={disabled}
      to={to}
      isHeaderLink={isHeaderLink}
      target={targetBlank ? "_blank" : undefined}
      onClick={onClick}
    >
      {children || label}
    </Link>
  );
}

export * from "./types";
